<template>
  <section class="minutes-watched">
    <h6 class="dashboard__tab-sub-title">Monthly trends</h6>
    <div class="minutes-watched__content">
      <div class="minutes-watched__chart-wrapper">
        <canvas
          ref="minutes-watched"
          :id="`minutes-watched`"
          class="minutes-watched__chart"
          height="210"
        ></canvas>
      </div>
    </div>
  </section>
</template>

<script>
import Chart from 'chart.js'
import 'chartjs-adapter-date-fns'

export default {
  name: 'MinutesWatchedChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartId: `minutes-watched`,
      chartOptions: {
        legend: {
          display: false,
          labels: {
            boxWidth: 0,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        showScale: false,
        scales: {
          yAxes: [
            {
              display: false,
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                fontColor: '#AFB0BF',
                padding: 15,
              },
              gridLines: {
                borderDash: [3, 3],
                color: '#666666',
              },
            },
          ],
        },
      },
      chartData: {
        type: 'line',
        data: {
          labels: this.data.months,
          datasets: [
            {
              label: 'Minutes Watched: ',
              data: this.data.values,
              borderColor: '#A793F6',
              backgroundColor: '#A793F680',
              fill: true,
            },
          ],
        },
      },
    }
  },
  methods: {
    createChart(ctx, chartData) {
      const minutesWatchedChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: this.chartOptions,
      })
      return minutesWatchedChart
    },
  },
  mounted() {
    const ctx = this.$refs['minutes-watched'].getContext('2d')
    this.createChart(ctx, this.chartData)
  },
}
</script>

<style lang="scss">
.minutes-watched {
  margin: 0 0 20px;
  @include mobile {
    margin: 0 0 30px;
  }
  &__title {
    color: var(--white);
    font-size: 1.5rem;
    padding: 0 0 5px 0;
    border-bottom: 1px solid var(--orange);
    margin: 2rem 0;
    @include tablet {
      width: 385px;
      white-space: nowrap;
    }
  }
  &__content {
    padding: 30px;
    background: var(--glass-mid-gray);
    min-width: 100%;
    border-radius: 10px;
  }
  &__chart-wrapper {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  &__chart {
    width: 100% !important;
  }
}
</style>
